import {Component} from 'react';
import h from 'react-hyperscript';
import './GoogLoginButton.scss';
import googleIcon from 'Assets/google-icon.svg';

class GoogLoginButton extends Component {
  render() {
    return (
      h('button', {
        type: 'button',
        className: 'google-button google-button--login',
        id: this.props.id,
        onClick: (e) => {
          this.props.onClick(e);
        },
      }, [
        h('span', {
          key: 0,
          className: 'google-button__icon',
        }, h('img', {
          alt: 'Google Logo',
          src: googleIcon,
        }, null)),
        h('span', {
          key: 1,
          className: 'google-button__text',
        }, 'Sign in with Google'),
      ])
    );
  }
}

export default GoogLoginButton;
